import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: 'countries',
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  isSelectable: true,
  isMultiSelectable: true,
  getURL: 'countriesPaginate',
  emptyMessage: "There is no provider associated",
  sessionParams:[],
  fields: [
    {
      attributeName: 'code',
      label: 'Code',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: true,
      canFilter:true,
      canEdit: false,
      canCreate: false,
      helpText: 'Code of the Country.',
    },
     {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: true,
      canFilter:true,
      canEdit: false,
      canCreate: false,
      helpText: 'Name of the Country.',
    },
  ],
};
